// Typed client for the banepad device-pairing registry, promoted out of the KV
// bridge to a relational table (Stage 2). On the `http` backend these hit the
// dedicated /banepad-devices endpoint (real Postgres); on memory/tests they fall
// back to the key/value Storage the app used before (`banepad_devices_v1`), so
// behavior off the http backend is unchanged. Whole-collection GET/PUT — the
// boundary in ../banepadDevices.ts reads/writes the full list.
import { Storage } from '../storage';
import { apiFetch } from './http';

const KEY = 'banepad_devices_v1';

export async function fetchBanepadDevices(): Promise<any[]> {
  if (Storage.backend === 'http') {
    const res = await apiFetch('/banepad-devices');
    if (!res.ok) return [];
    return (await res.json()) as any[];
  }
  const r = await Storage.get(KEY);
  return r?.value ? JSON.parse(r.value) : [];
}

export async function persistBanepadDevices(list: any[]): Promise<void> {
  if (Storage.backend === 'http') {
    const res = await apiFetch('/banepad-devices', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(list),
    });
    if (!res.ok) throw new Error('[banepad-devices] PUT failed: ' + res.status);
    return;
  }
  await Storage.set(KEY, JSON.stringify(list));
}
